<template>
    <div>
        <v-layout row wrap class="ma-8">
            <v-flex xs12>
                <v-card class='grey lighten-4'>
                    <v-layout row wrap>

                        <v-flex xs12>
                            <h2 class="font-weight-bold text-center">Program Coordinator Performance Evaluation</h2>
                            <v-divider class="ml-12 mr-12 mt-5"></v-divider>

                        </v-flex>


                        <v-flex xs6 class="pa-5">
                            <v-select 
                                label="Select an Employee to Review"
                                v-model="employeeName"
                                :items="users"
                                item-value="_id"
                                item-text="Name"
                            ></v-select>
                        </v-flex>

                        <v-flex xs6 class="pa-5">
                            <v-text-field 
                                label="Date of Review"
                                v-model="employeeDate"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs3>
                            
                        </v-flex>

                        <v-flex xs3>
                           <h3>Score</h3>
                        </v-flex>

                        <v-flex xs6>
                            <h3>Task Description</h3>
                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Individuals</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="individual1"
                                            @input="updateScore()"
                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{individual1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Timely follow up of the individuals concerns and needs.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="individual2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{individual2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Communicate/Mediate with parents/guardians, service coordinators
                                            and others as necessary.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="individual3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{individual3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all individuals books are kept current, filing complete,
                                            annual forms current and ensure that related other paperwork is complete,
                                            current and audit ready.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="individual4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{individual4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all individuals personal hygiene needs are met and they are 
                                            presented in the community well groomed. Wheelchairs are maintained
                                            and repaired in a timely manner.
                                        </p>
                                    </v-flex>

                                    <!-- <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                       <v-rating 
                                            length="5"
                                            v-model="individual5"
                                            @input="updateScore()"
                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{individual5}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Timely follow up of the individuals concerns and needs.
                                        </p>
                                    </v-flex> -->


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Staffing</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="staffing1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Oversee initial site staff training and monthly staff trainings.
                                            Post and schedule staff to attend other mandatory trainings. Train staff
                                            on the importance of goals, medications, dress standards, and maintaining
                                            employment requirements.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="staffing2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Complete staff evaluations each January and July. Communicate extraordinary
                                            warnings with Human Resources. Follow through with staff disciplinary actions.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="staffing3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Address staff issues and problem solve in a positive manner. Create ways
                                            to build positive staff morale.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="staffing4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Communicate and work with Human Resources on required paperwork.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="staffing5"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing5}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that staff interact with individuals in an age appropriate 
                                            manner, keeping dignity, respect and confidentiality in all interactions.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Security Standards</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="security1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{security1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that the highest standard of security/confidentiality 
                                            is maintained.  Report security violations to supervisor.  Know 
                                            and train staff on all security and emergency plans.  Oversee that 
                                            all regularly scheduled fire drills are conducted and documented.  
                                            Ensure that staff and clients are proficient with the site emergency plan.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="security2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{security2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Maintain adequate staffing.  Obtain prior approval for overtime.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Program</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="program1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                     <v-flex xs3>
                                        {{program1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure site(s) are audit compliant and follow up with recommendations.  
                                            Ensure compliance to DRC and  policies and procedures for self and staff.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="program2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                     <v-flex xs3>
                                        {{program2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Oversee site maintenance inside and out.  
                                            Report to appropriate person maintenance requests.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="program3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                     <v-flex xs3>
                                        {{program3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Follow the chain of command.  Use proper procedures when 
                                            interacting with government entities. Complete tasks on 
                                            time and accurately.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="program4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                     <v-flex xs3>
                                        {{program4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that payroll is accurate, complete and submitted on time.  
                                            Ensure that timecards are reviewed, missing electronic punches 
                                            are explained and initialed, and employee and manager signatures 
                                            are present. Mileage sheets complete, and submitted with payroll.  
                                            Two weeks of schedules are submitted with payroll.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Transportation</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="transportation1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{transportation1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Turn in vehicle trip sheets with payroll. 
                                            Ensure that they are complete and accurate.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="transportation2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{transportation2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that staff are aware of  transportation policies 
                                            and procedures and are compliant. Properly train authorized 
                                            employees to drive company vehicles, complete required documentation 
                                            and properly secure individuals in safety belts and wheelchair straps.  
                                            Ensure that only authorized employees drive company vehicles and their 
                                            own vehicles for company business.
                                        </p>
                                    </v-flex>

                                    <!-- <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="transportation3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{transportation3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all individuals books are kept current, filing complete,
                                            annual forms current and ensure that related other paperwork is complete,
                                            current and audit ready.
                                        </p>
                                    </v-flex> -->


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Medical</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="medical1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{medical1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Oversee that all medical needs for individuals are met.  
                                            Ensure appoints are attended and follow up is complete and 
                                            communicated to staff for appropriate follow up of doctor orders.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                       <v-rating 
                                            length="5"
                                            v-model="medical2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{medical2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Communicate emergency room visits to supervisor, parents/guardians, 
                                            service coordinators, and others as needed.  Follow up with required paperwork 
                                            to office and DRC.  Communicate hospital stays, surgeries, etc. to appropriate 
                                            persons.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="medical3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{medical3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that staff is competent with medications, medication forms and 
                                            medication procedures.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Goals</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="goals1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{goals1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that individuals’ are working on their goals.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="goals2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{goals2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Oversee that staff know the individuals goals and assist 
                                            them as necessary.  Ensure that staff complete goal forms 
                                            accurately and on time.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="goals3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{goals3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Oversee that an annual meeting is held for individuals on or before the 
                                            annual date.  Complete paperwork prior to the meeting and be prepared 
                                            for the meeting.  Complete required paperwork after the meeting.  
                                            Ensure quality of forms, accuracy and forward the forms to the proper 
                                            people in a timely manner.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="goals4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{goals4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Complete monthly summaries accurately and on time.  
                                            Make suggestions for needed changes.  Ensure compliance of goals 
                                            from staff and ensure proper documentation in goal books.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="goals5"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{goals5}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Encourage individuals and staff get in the community and be 
                                            involved in a variety of community activities.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Finances</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="finances1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{finances1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Maintain daily finances for individuals.  
                                            Monitor budgets, accounts and checkbooks.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="finances2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{finances2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Effectively follow SSA/SSI/Medicaid guidelines and policies.  
                                            Never allow accounts to exceed $2000.00 or allow accounts to have 
                                            a negative balance. Maintain all finances audit compliant as per DRC 
                                            guidelines.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="finances3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{finances3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure all bills are paid on time, bills are split evenly among roommates,
                                            receipts are kept, initialed by two staff persons.  Checks are signed by 
                                            individual and  staff person.  Grocery shopping is done regularly, checks 
                                            made payable to the store and cash back never received.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="finances4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{finances4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all money is accounted for, that individuals and 
                                            staff don not loan or borrow money or anything else.  Ensure 
                                            that individuals do not write checks to employees.
                                        </p>
                                    </v-flex>

                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Personal Development</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Attend monthly manager meetings.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Communicate and network with community agencies, 
                                            parents/guardians and DRC.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Communicate in a timely fashion days off with supervisor.  
                                            Make arrangements for coverage when off.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Make good use of time. Prioritize assignments/projects.  Dress appropriately.  
                                            Delegate work when needed.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal5"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal5}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure management coverage for all shifts.  
                                            Make unexpected drop in visits for all shifts (Day, afternoon, 
                                            night, graveyard and weekends).  Ensure documentation and follow up 
                                            for those visits. 
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal6"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal6}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that each house and day program have adequate 
                                            staffing to maintain all ratios.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal7"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal7}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all staff are trained according to RHS 
                                            Policies and Procedures.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal8"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal8}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all state required investigations are completed 
                                            within the timeframe specified by the state.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal9"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal9}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all Incident Reports are completed as required by 
                                            the state and submitted as specified by the state.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12>
                            <v-card class="ma-3">
                                <v-card-title class="font-weight-bold ml-3">Overall Evaluation</v-card-title>
                                <v-layout row wrap>

                                    <v-flex xs12 class="pl-8">
                                        Evaluation Score: {{parseFloat(scoreTotal).toFixed(2)}}
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-textarea 
                                            label="Improvement Opportunities"
                                            v-model="improvement"
                                        ></v-textarea>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-textarea 
                                            label="Successes"
                                            v-model="successes"
                                        ></v-textarea>
                                    </v-flex>

                                    <v-flex xs12 class="pa-6">
                                        <v-card-subtitle>This evaluation has been discussed and my questions answered.</v-card-subtitle>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-text-field 
                                            label="Staff Name"
                                            v-model="staffName"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-text-field 
                                            label="Date"
                                            v-model="staffDate"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-text-field 
                                            label="Program Director"
                                            v-model="programDirector"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-text-field 
                                            label="Date"
                                            v-model="programDate"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 class="pa-5">
                                        <v-btn @click="addReview()">Submit Review</v-btn>
                                    </v-flex>

                                </v-layout>
                            </v-card>
                        </v-flex>

                    </v-layout>
                </v-card>
            </v-flex>

            
            
        </v-layout>

    </div>
</template>
<script>
import axios from 'axios'

const url = require("../../client_config/config").url;


export default {
    data: () => ({
        users: [],
        review: "Program Coordinator",
        employeeName: "",
        employeeDate: "",
        individual1: 0,
        individual2: 0,
        individual3: 0,
        individual4: 0,
        // individual5: 0,
        staffing1: 0,
        staffing2: 0,
        staffing3: 0,
        staffing4: 0,
        staffing5: 0,
        security1: 0,
        security2: 0,
        program1: 0,
        program2: 0,
        program3: 0,
        program4: 0,
        transportation1: 0,
        transportation2: 0,
        // transportation3: 0,
        medical1: 0,
        medical2: 0,
        medical3: 0,
        goals1: 0,
        goals2: 0,
        goals3: 0,
        goals4: 0,
        goals5: 0,
        finances1: 0,
        finances2: 0,
        finances3: 0,
        finances4: 0,
        personal1: 0,
        personal2: 0,
        personal3: 0,
        personal4: 0,
        personal5: 0,
        personal6: 0,
        personal7: 0,
        personal8: 0,
        personal9: 0,
        scoreTotal: 0,
        improvement: "",
        successes: "",
        staffName: "",
        staffDate: "",
        programDirector: "",
        programDate: "",
        staffId: "",
    }),

    created() {
        this.getUsers()
    },

    methods: {
        getUsers() {
            axios.get(`${url}/users`).then( res => {
                this.users = res.data.users
            })
        },
        updateScore () {
            this.scoreTotal = (
                this.individual1 
                + this.individual2 
                + this.individual3 
                + this.individual4 
                + this.staffing1 
                + this.staffing2 
                + this.staffing3 
                + this.staffing4 
                + this.staffing5 
                + this.security1 
                + this.security2 
                + this.program1 
                + this.program2 
                + this.program3 
                + this.program4 
                + this.transportation1 
                + this.transportation2 
                + this.medical1 
                + this.medical2 
                + this.medical3 
                + this.goals1 
                + this.goals2 
                + this.goals3 
                + this.goals4 
                + this.goals5 
                + this.finances1 
                + this.finances2 
                + this.finances3 
                + this.finances4 
                + this.personal1 
                + this.personal2 
                + this.personal3 
                + this.personal4 
                + this.personal5 
                + this.personal6 
                + this.personal7 
                + this.personal8 
                + this.personal9
                
                ) / parseInt(38)
        },

        addReview: function() {
        var req_body = {
            Review: this.review,
            EmployeeName: this.employeeName,
            EmployeeDate: this.employeeDate,
            Individual1: this.individual1,
            Individual2: this.individual2,
            Individual3: this.individual3,
            Individual4: this.individual4,
            // Individual5: this.individual5,
            Staffing1: this.staffing1,
            Staffing2: this.staffing2,
            Staffing3: this.staffing3,
            Staffing4: this.staffing4,
            Staffing5: this.staffing5,
            Security1: this.security1,
            Security2: this.security2,
            Program1: this.program1,
            Program2: this.program2,
            Program3: this.program3,
            Program4: this.program4,
            Transportation1: this.transportation1,
            Transportation2: this.transportation2,
            // Transportation3: this.transportation3,
            Medical1: this.medical1,
            Medical2: this.medical2,
            Medical3: this.medical3,
            Goals1: this.goals1,
            Goals2: this.goals2,
            Goals3: this.goals3,
            Goals4: this.goals4,
            Goals5: this.goals5,
            Finances1: this.finances1,
            Finances2: this.finances2,
            Finances3: this.finances3,
            Finances4: this.finances4,
            Personal1: this.personal1,
            Personal2: this.personal2,
            Personal3: this.personal3,
            Personal4: this.personal4,
            Personal5: this.personal5,
            Personal6: this.personal6,
            Personal7: this.personal7,
            Personal8: this.personal8,
            Personal9: this.personal9,
            ScoreTotal: this.scoreTotal,
            Improvement: this.improvement,
            Successes: this.successes,
            StaffName: this.staffName,
            StaffDate: this.staffDate,
            ProgramDirector: this.programDirector,
            ProgramDate: this.programDate,
            StaffID: this.staffID,
        };

        axios.post(`${url}/performanceReview`, req_body).then((res) => {
            // this.getDiagnoses();
            if (res.status == 400) {
            res.json().then(function(data) {
                this.text = data.msg;
            });
            }
            this.employeeName= "",
            this.employeeDate= "",
            this.individual1= 0,
            this.individual2= 0,
            this.individual3= 0,
            this.individual4= 0,
            this.individual5= 0,
            this.staffing1= 0,
            this.staffing2= 0,
            this.staffing3= 0,
            this.staffing4= 0,
            this.staffing5= 0,
            this.security1= 0,
            this.security2= 0,
            this.program1= 0,
            this.program2= 0,
            this.program3= 0,
            this.program4= 0,
            this.transportation1= 0,
            this.transportation2= 0,
            this.transportation3= 0,
            this.medical1= 0,
            this.medical2= 0,
            this.medical3= 0,
            this.goals1= 0,
            this.goals2= 0,
            this.goals3= 0,
            this.goals4= 0,
            this.goals5= 0,
            this.finances1= 0,
            this.finances2= 0,
            this.finances3= 0,
            this.finances4= 0,
            this.personal1= 0,
            this.personal2= 0,
            this.personal3= 0,
            this.personal4= 0,
            this.personal5= 0,
            this.scoreTotal= 0,
            this.improvement= "",
            this.successes= "",
            this.staffName = "",
            this.staffDate = "".
            this.programDirector= "",
            this.programDate= "",
            this.msg = true;
            this.text = "The new diagnoses has been added successfully.";
        });
        this.close();
        },

    }
}
</script>